<template>
  <div class="min-w-full">
    <div class="w-full grid grid-cols-2 gap-4">
      <div>
        <h1 class="mb-8 font-bold text-3xl">
          Notes
        </h1>
      </div>
      <div class="text-right">
        <div v-show="!toggle" class="cursor-pointer duration-300 noteDiv text-indigo-500" @click="toggle = !toggle">
          <i class="fas fa-plus text-3xl" />
        </div>
        <div v-show="toggle" class="cursor-pointer duration-300 noteDiv text-indigo-500" @click="toggle = !toggle">
          <i class="fas fa-minus text-3xl" />
        </div>
      </div>
    </div>
    <div class="bg-white rounded-md shadow">
      <div v-show="toggle" class="p-6 min-w-max">
        <form id="noteForm" name="noteForm" @submit.prevent="addNote">
          <h2 class="font-bold mb-4">
            Add Note
          </h2>
          <textarea-input id="note" v-model="noteForm.note" :error="noteForm.errors.note" name="note" rows="3"
            class="pb-4 w-full" />
          <div class="flex justify-center items-center">
            <div>
              <loading-button :loading="noteForm.processing" class="btn-indigo ml-auto" type="submit">Save
                Note</loading-button>
            </div>
          </div>
        </form>
      </div>
      <div class="p-6">
        <div id="selectNotes" class="container flex justify-center items-center">
          <div class="noteDiv">
            <label>
              <input v-model="selectedType" type="radio" value="All" />
              <i class="fas fa-list-ul text-gray-400 text-2xl noteIcon" />
            </label>
          </div>
          <div class="noteDiv">
            <label>
              <input v-model="selectedType" type="radio" value="text" />
              <i class="fas fa-sms text-red-400 text-2xl noteIcon" />
            </label>
          </div>
          <div class="noteDiv">
            <label>
              <input v-model="selectedType" type="radio" value="note" />
              <i class="far fa-sticky-note text-blue-400 text-2xl noteIcon" />
            </label>
          </div>
          <div class="noteDiv">
            <label>
              <input v-model="selectedType" type="radio" value="email" />
              <i class="far fa-envelope text-green-400 text-2xl noteIcon" />
            </label>
          </div>
          <div class="noteDiv">
            <label>
              <input v-model="selectedType" type="radio" value="call" />
              <i class="fas fa-mobile-alt text-pink-400 text-2xl noteIcon" />
            </label>
          </div>
          <div class="noteDiv">
            <label>
              <input v-model="selectedType" type="radio" value="admin" />
              <i class="fas fa-cogs text-gray-400 text-2xl noteIcon" />
            </label>
          </div>
        </div>
        <div class="bg-white rounded shadow">
          <table class="table-fixed p-5 w-full">
            <thead>
              <tr class="text-left font-bold">
                <th class="w-1/5 p-5">Type</th>
                <th class="w-3/5 p-5">Note</th>
                <th class="w-1/5 p-5" />
              </tr>
            </thead>
            <tbody>
              <tr v-for="note in filteredNotes" :key="note.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t p-2 text-center">
                  <div>
                    <div class="w-full">
                      <IconNotes :name="note.type" class="w-full" />
                    </div>
                    <div class="w-full">
                      <span class="text-xs">
                        {{ note.type }}
                      </span>
                    </div>
                  </div>
                </td>
                <td class="border-t p-2 text-sm">
                  <div class="w-full text-xs mb-4">{{ datestamp(note.created_at) }} {{ timestamp(note.created_at) }}
                  </div>
                  <div v-if="note.type === 'email'" class="w-full text-xs mb-4">Opens: {{ note.opens }} Clicks: {{
                    note.clicks }}</div>
                  <div class="w-full"><span v-html="note.message" /></div>
                </td>
                <td class="border-t p-2 text-right">
                  <button class="text-red-600 px-2 py-2 hover:underline" tabindex="-1" @click="destroyNote(note.id)">
                    <i class="ml-2 fas fa-times text-red-500" />
                  </button>
                </td>
              </tr>
              <tr v-if="notes.length === 0">
                <td class="border-t p-2 text-center" colspan="4">No Notes.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Pagination from '@/Shared/Pagination'
import moment from 'moment'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import IconNotes from '@/Shared/IconNotes'
import { ref, onMounted, onUnmounted } from 'vue'
import { router, usePoll } from '@inertiajs/vue3'

export default {
  name: 'Notes',
  components: {
    IconNotes,
    TextareaInput,
    // Pagination,
    LoadingButton,
  },
  props: {
    notes: Array,
    contact: Object,
    auth: Object,
  }, setup() {
    const isPolling = ref(false)
    let pollInterval = null

    const startPolling = () => {
      if (!isPolling.value) {
        isPolling.value = true
        pollInterval = setInterval(() => {
          router.reload({
            only: ['notes'],
            preserveState: true,
            preserveScroll: true,
            replace: true,
          })
        }, 15000)
      }
    }

    const stopPolling = () => {
      if (isPolling.value) {
        isPolling.value = false
        clearInterval(pollInterval)
      }
    }

    onMounted(() => {
      startPolling()
    })

    onUnmounted(() => {
      stopPolling()
    })

    return {
      isPolling,
      startPolling,
      stopPolling
    }
  },
  data() {
    return {
      noteForm: router.form({
        note: null,
        type: 'note',
        contact_id: this.contact.id,
      }),
      selectedType: 'All',
      toggle: false,
    }
  },
  computed: {
    timeFormatted() {
      return moment(this.givenDate).format('YYYY')
    },
    filteredNotes: function () {
      //if adding pagination add .data to notes and add paginate in leadsController

      if (this.selectedType === 'All') {
        return this.notes
      } else {
        return this.notes.filter(note => {
          return note.type.toLowerCase().includes(this.selectedType.toLowerCase())
          // return note.type.toLowerCase() == this.selectedType.toLowerCase()
        })
      }
    },
  },
  methods: {
    timestamp: function (date) {
      return moment(date).format('h:mm A')
    },
    datestamp: function (date) {
      return moment(date).format('MM/DD/YY')
    },
    addNote() {
      this.noteForm.post('/notes', {
        preserveScroll: true,
        preserveState: true,
        onSuccess: () => {
          this.noteForm.reset('note')
        },
      })
    },
    destroyNote(id) {
      router.delete(('/notes/' + id), { only: ['notes'], preserveScroll: true })
    },
  },
}
</script>
<style scoped>
/* HIDE RADIO */
[type=radio] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.noteDiv {
  padding: 10px;
}

.noteIcon:hover {
  cursor: pointer;
  font-weight: 800;
  font-size: 40px;
}

/* CHECKED STYLES */
[type=radio]:checked+.noteIcon {
  font-weight: 800;
  font-size: 40px;
}
</style>
